import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NotificationComponent } from './shared/components/notification/notification.component';
import { NotificationService } from './shared/services/notification.service';
import { AuthService } from './core/services/auth.service';
import { effect } from '@angular/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NotificationComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class App {
  protected readonly title = signal('front-kpi');

  notification;

  constructor(private notify: NotificationService, private auth: AuthService) {
    this.notification = this.notify.state;
  }

  // 🔐 Validar sesión al iniciar la app
  private readonly restoreSessionEffect = effect(() => {
    const hasToken = !!localStorage.getItem('kpi_token');

    if (!hasToken) return;

    this.auth.me().subscribe({
      next: (user) => {
        this.auth.restoreUser(user);
      },
      error: () => {
        this.auth.logout();
      },
    });
  });
}
